import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {MantenedorSolicitudPedidoVentaService} from "../../../../services/mantenedor-solicitud-pedido-venta.service";
import {DatosMaestrosService} from "../../../../../../services/datos-maestros.service";
import {moduloAutoconsumo} from "../../../../diccionarios/autoconsumoModulo";

@Component({
  selector: 'app-imputacion',
  templateUrl: './imputacion.component.html',
  styleUrls: ['./imputacion.component.css']
})
export class ImputacionComponent implements OnInit {
  DAT_MSG: any;
  DAT_BTNS: any;
  textBoton: string;
  editableForm: boolean = false;
  formularioImputacion: FormGroup;
  loading: boolean = false;
  diccionarioModulo: any = {};
  cmbTipoImputacion: any[];
  cmbElemento: any[];
  @Input() solicitudData: any;


  constructor(
    private fb: FormBuilder,
    private _mantenedorSolicitudPedidoVentaService: MantenedorSolicitudPedidoVentaService,
    private _datosMaestrosService: DatosMaestrosService,
  ) {
    this.diccionarioModulo = moduloAutoconsumo;
  }


  ngOnInit(): void {
    this.DAT_BTNS = moduloAutoconsumo.button.buttonsNombre;
    this.DAT_MSG = moduloAutoconsumo.mensajes;
    this.textBoton = moduloAutoconsumo.button.buttonsNombre.agregar;
    this.cmbTipoImputacion = this.diccionarioModulo.tipoImputacionArray;
    this.formularioImputacion = this.fb.group({
      tipoImputacion: ['', [Validators.required]],
      tipoImputacionDescripcion: ['', [Validators.required]],
      elemento: ['', [Validators.required]],
      porcentaje: ['', [Validators.required, this.porcentajeValidator(), this.porcentajeValidatorMax()]],
      porcentajeTotalArray: [''],
      importeImputacion: ['', [Validators.required]],
      posicion: ['', [Validators.required]],
      lineaImputacion: ['', [Validators.required]],
      idPedido: [null],
      descElemento: ['', []],
    });
    this.formatInitInformation(this.solicitudData);
    this.formularioImputacion.get('porcentaje').valueChanges.subscribe(nuevoValor => {
      this.changePorcentaje();
    });
    //console.log(this.solicitudData);
  }

  formatInitInformation(solicitudData) {
    //console.log(solicitudData);
    if (solicitudData && solicitudData.imputacionEvent && solicitudData.imputacionEvent === 'nuevo') {
      if (solicitudData && solicitudData.imputacionArray) {
        this.formularioImputacion.get('lineaImputacion').setValue(solicitudData.imputacionArray ? solicitudData.imputacionArray.length + 1 : 1);
      }
      if (solicitudData && solicitudData.detallePosicion) {
        this.formularioImputacion.get('posicion').setValue(solicitudData.detallePosicion);
      }
      if (solicitudData && solicitudData.idPedido) {
        this.formularioImputacion.get('idPedido').setValue(solicitudData.idPedido);
      }
    } else {
      this.formularioImputacion.get('tipoImputacion').setValue(this.cmbTipoImputacion.find(data => data.id === solicitudData.data.tipoImputacion).id);
      this.formularioImputacion.get('tipoImputacionDescripcion').setValue(this.cmbTipoImputacion.find(data => data.id === solicitudData.data.tipoImputacion).descripcion);
      this.formularioImputacion.get('porcentaje').setValue(solicitudData.data.porcentaje);
      this.formularioImputacion.get('elemento').setValue(solicitudData.data.elemento);
      //this.formularioImputacion.get('descElemento').setValue(this.cmbElemento.find(data => data.id === solicitudData.data.elemento).descripcion);
      this.formularioImputacion.get('importeImputacion').setValue(solicitudData.data.importeImputacion);
      this.formularioImputacion.get('posicion').setValue(solicitudData.data.posicion);
      this.formularioImputacion.get('lineaImputacion').setValue(solicitudData.data.lineaImputacion);
      this.formularioImputacion.get('idPedido').setValue(solicitudData.data.idPedido);
      this.initElemento(true);
    }
    this.formularioImputacion.get('porcentajeTotalArray').setValue(this.calcularTotalPorcentaje(this.solicitudData.imputacionArray));
    //console.log(this.formularioImputacion.value);
  }


  acciones(event) {
    if (event === 'guardar') {
      if (this.editableForm) {
      } else {
        this.agregar();
      }
    } else {
      this.regresar();
    }
  }

  calcularTotalPorcentaje(imputacionArray) {
    let totalPorcentaje = 0;
    imputacionArray.forEach((imputacion: any) => {
      if (imputacion && imputacion.porcentaje && imputacion.porcentaje !== '') {
        if (!(this.solicitudData && this.solicitudData.imputacionEvent && this.solicitudData.imputacionEvent !== 'nuevo' && this.solicitudData.data.posicion === imputacion.posicion && this.solicitudData.data.lineaImputacion === imputacion.lineaImputacion)) {
          totalPorcentaje = totalPorcentaje + parseFloat(String(imputacion.porcentaje));
        }
      }
    });
    return totalPorcentaje;
  }

  porcentajeValidator() {
    return (control) => {
      const porcentaje = control.value;
      if (porcentaje === null || porcentaje === undefined) {
        return null;
      }

      if (isNaN(porcentaje)) {
        return {'invalidPorcentaje': true};
      }

      if (porcentaje < 0 || porcentaje > 100) {
        return {'outOfRange': true};
      }

      return null;
    };
  }

  porcentajeValidatorMax() {
    return (control) => {
      //console.log('porcentajeValidatorMax', control)
      let porcentaje = 0;
      if (control && control.value && control.value !== '') {
        porcentaje = control.value || 0;
      }
      let porcentajeTotalArray = 0;
      if (this.formularioImputacion && this.formularioImputacion.get('porcentajeTotalArray') && this.formularioImputacion.get('porcentajeTotalArray').value && this.formularioImputacion.get('porcentajeTotalArray').value !== '') {
        porcentajeTotalArray = this.formularioImputacion.get('porcentajeTotalArray').value || 0;
      }
      const sumaPorcentajes = parseFloat(String(porcentaje)) + parseFloat(String(porcentajeTotalArray));

      return sumaPorcentajes > 100 ? {sumaPorcentajesExcede: true} : null;
    };
  }


  agregar() {
    //console.log('prueba Alfredo');
    if (this.solicitudData && this.solicitudData.imputacionEvent && this.solicitudData.imputacionEvent === 'nuevo') {
      this.solicitudData.imputacionArray.push(this.formularioImputacion.value);
      console.log('fromularioImp->',this.formularioImputacion.value);
      console.log('solicitud data->',this.solicitudData);
      console.log('solicitud array->',this.solicitudData.imputacionArray);
      this._mantenedorSolicitudPedidoVentaService.imputacionEvent({
        action: 'nuevo',
        result: this.solicitudData.imputacionArray
      });
    } else if (this.solicitudData && this.solicitudData.imputacionEvent && this.solicitudData.imputacionEvent === 'editar') {
      const newArrayImputacion = this.solicitudData.imputacionArray.map((item) =>
        item.lineaImputacion === this.formularioImputacion.get('lineaImputacion').value ? this.formularioImputacion.value : item
      );
      this._mantenedorSolicitudPedidoVentaService.imputacionEvent({
        action: 'editar',
        result: newArrayImputacion
      });
    }
    this.formularioImputacion.reset();
  }


  regresar() {
    //console.log('prueba Alfredo');
    this.formularioImputacion.reset();
    this._mantenedorSolicitudPedidoVentaService.imputacionEvent({
      action: 'regresar',
      result: ''
    });
  }

  initElemento(firstTime?) {
    //console.log(this.formularioImputacion.get('tipoImputacion').value);

    if (
      this.formularioImputacion &&
      this.formularioImputacion.get('tipoImputacion') &&
      this.formularioImputacion.get('tipoImputacion').value !== ''
    ) {
      this.loading = true;

      const tipoImputacionValue = this.formularioImputacion.get('tipoImputacion').value;

      if (tipoImputacionValue === this.cmbTipoImputacion[0].id) {
        this._datosMaestrosService.getAllElementoPEP().subscribe(
          (elementosPEP: any) => {
            elementosPEP.map((data) => {
              data.id = data.idElementoPEP;
              data.onlydescription = data.descripcion;
              data.descripcion = data.idElementoPEP + ' | ' + data.descripcion;

            });
            this.cmbElemento = elementosPEP.sort((a, b) => a.idElementoPEP.localeCompare(b.idElementoPEP));
            console.log(this.cmbElemento);
            if (!firstTime) {
              this.formularioImputacion.get('elemento').setValue('');
            }
            this.loading = false;
          },
          (error) => {
            this.cmbElemento = [];
            this.formularioImputacion.get('elemento').setValue('');
            this.loading = false;
          }
        );
      } else if (tipoImputacionValue === this.cmbTipoImputacion[1].id) {
        this._datosMaestrosService.getAllOrdenInternaDmaestros().subscribe(
          (ordenInternaList: any) => {
            ordenInternaList.map((data) => {
              data.id = data.idOrdenInterna;
              data.onlydescription = data.descripcion;
              data.descripcion = data.idOrdenInterna + ' | ' + data.descripcion;

            });
            this.cmbElemento = ordenInternaList.sort((a, b) => a.idOrdenInterna.localeCompare(b.idOrdenInterna));
            if (!firstTime) {
              this.formularioImputacion.get('elemento').setValue('');
            }
            this.loading = false;
          },
          (error) => {
            this.cmbElemento = [];
            this.formularioImputacion.get('elemento').setValue('');
            this.loading = false;
          }
        );
      } else if (tipoImputacionValue === this.cmbTipoImputacion[2].id) {
        this._datosMaestrosService.getAllCentroCostos().subscribe(
          (centroCostoList: any) => {
            centroCostoList.map((data) => {
              data.id = data.idCentroCosto;
              data.onlydescription = data.descripcion;
              data.descripcion = data.idCentroCosto + ' | ' + data.descripcionCentroCosto;
            });
            this.cmbElemento = centroCostoList.sort((a, b) => a.idCentroCosto.localeCompare(b.idCentroCosto));
            if (!firstTime) {
              this.formularioImputacion.get('elemento').setValue('');
            }
            this.loading = false;
          },
          (error) => {
            this.cmbElemento = [];
            this.formularioImputacion.get('elemento').setValue('');
            this.loading = false;
          }
        );
      } else {
        // Otros casos
      }
    }
  }


  changeTipoImputacion() {
    this.formularioImputacion.get('tipoImputacionDescripcion').setValue(
      this.cmbTipoImputacion.find(data => data.id === this.formularioImputacion.get('tipoImputacion').value)?.descripcion || ''
    );
    this.initElemento();
  }

  changePorcentaje() {
    //console.log(this.solicitudData.formularioLineaDetalle.importe)
    //console.log(this.formularioImputacion.get('porcentaje').value)
    if (this.formularioImputacion && this.formularioImputacion.get('porcentaje') && this.formularioImputacion.get('porcentaje').value && this.formularioImputacion.get('porcentaje').value !== '') {
      this.formularioImputacion.get('importeImputacion').setValue(this.solicitudData.formularioLineaDetalle.importe * this.formularioImputacion.get('porcentaje').value / 100)
    } else {
      this.formularioImputacion.get('importeImputacion').setValue(0)
    }
  }

  changeElement() {
    console.log(this.formularioImputacion.get('elemento').value)
    this.formularioImputacion.get('descElemento').setValue(
      this.cmbElemento.find(data => data.id === this.formularioImputacion.get('elemento').value)?.onlydescription || ''
    ) //  descElemento
    console.log('ingreso cchanged', this.formularioImputacion.get('descElemento').value);
  }

}
